<template>
  <div v-if="customer">
    <div class="row mt-3">
      <div class="col-md-12 content-list mb-2">
        <b>First Name:</b>
        <span v-if="!editModeValue">{{ customer.firstName }}</span>
        <span>
          <input
            v-if="editModeValue"
            v-model="customerEdit.firstName"
            :class="{ 'is-invalid': $v.customerEdit.firstName.$invalid}"
            class="form-control"
          >
        </span>
      </div>
      <div class="col-md-12 content-list mb-2">
        <b>Last Name:</b>
        <span v-if="!editModeValue">{{ customer.surname }}</span>
        <span>
          <input
            v-if="editModeValue"
            v-model="customerEdit.surname"
            :class="{ 'is-invalid': $v.customerEdit.surname.$invalid}"
            class="form-control"
          >
        </span>
      </div>
      <div class="col-md-12 content-list mb-2">
        <b>Email:</b>
        <span v-if="!editModeValue"><strong>{{ customer.email }}</strong></span>
        <span>
          <input
            v-if="editModeValue"
            v-model="customerEdit.email"
            :class="{ 'is-invalid': $v.customerEdit.email.$invalid}"
            class="form-control"
            type="email"
          >
        </span>
      </div>
      <div class="col-md-12 content-list mb-2">
        <b>Phone:</b>
        <span v-if="!editModeValue">{{ customer.mobilePhone }}</span>
        <span>
          <input
            v-if="editModeValue"
            v-model="customerEdit.mobilePhone"
            :class="{ 'is-invalid': $v.customerEdit.mobilePhone.$invalid}"
            class="form-control"
            type="tel"
          >
        </span>
      </div>
      <div class="col-md-12 content-list mb-2">
        <b>Postcode:</b>
        <span v-if="!editModeValue">{{ customer.postcode }}</span>
        <span>
          <input
            v-if="editModeValue"
            v-model="customerEdit.postcode"
            class="form-control"
          >
        </span>
      </div>
    </div>

    <button
      v-if="editModeValue"
      class="btn btn-secondary mt-3"
      @click="editModeValue = !editModeValue"
    >
      Cancel <i class="icon--cross" />
    </button>
    <button
      v-if="editModeValue"
      :disabled="$v.$invalid"
      class="btn btn-primary mt-3"
      @click="saveCustomer"
    >
      Save <i class="icon--floppy-disk" />
    </button>
  </div>
</template>

<script>
import { required, email, numeric } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

export default {
    name: 'Customer',
    props: ['editMode'],
    data () {
        return {
            customerEdit: null
        }
    },
    computed: {
        editModeValue: {
            get: function () {
                return this.editMode
            },
            set: function (newValue) {
                this.$emit('update:editMode', newValue)
            }
        },
        ...mapState({
            customer: state => state.booking.customer
        })
    },
    async created () {
        await this.$store.dispatch('getCustomer', this.$route.params.bookingId)
        this.customerEdit = Object.assign({}, this.customer)
    },
    validations: {
        customerEdit: {
            firstName: {
                required
            },
            surname: {
                required
            },
            email: {
                required,
                email
            },
            mobilePhone: {
                numeric
            }
        }
    },
    methods: {
        async saveCustomer () {
            const result = await this.$store.dispatch('updateCustomer', [this.$store.state.booking.bookingDetail.id, this.customerEdit])
            if (result.status === 200 || result.status === 201) {
                this.$toasted.success('Customer details saved')
                this.editModeValue = false

                this.$store.dispatch('getCustomer', this.$route.params.bookingId)
                this.$store.dispatch('getAudit', this.$route.params.bookingId)
            } else {
                this.$toasted.error(`Update Failed. ${result.data}`)
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
